export default {
  title: {
    login: '登錄',
    createPassword: '創建你的密碼',
    forgetPassword: '忘記密碼',
    resetPassword: '重置密碼',
    questionnaire: '滿意度調查',
    alert: '請查看您的郵件',
    statement: '隱私內容協議'
  },
  btn: {
    home: '首頁',
    forgetPassword: '忘記密碼',
    reset: '重置',
    confirm: '確認',
    upload: '上載',
    addEntry: '新增',
    remove: '刪除',
    back: '返回',
    cancel: '取消',
    next: '下一步',
    finish: '完成',
    submit: '提交',
    viewJobs: '查看所有職位',
    viewResume: '查看簡歷',
    viewApplicant: '查看申請狀態',
    viewHMDashboard: '查看招聘經理看板'
  },
  label: {
    year: '{year} 年',
    language: '語言',
    email: '郵箱',
    userName: '用戶名',
    firstName: '名',
    lastName: '姓',
    password: '密碼',
    reEnterPassword: '再次輸入密碼',
    agreeStatement: '我已經閱讀並接受隱私內容協議',
    toEmployeePortal: '去員工中心',
    statementBody: '',
    thanksLabel: '謝謝!',
    finishContent: '您的{questionnaire}已經提交，祝您好運！',
    moreInformation: '更多信息：',
    present: '至今',
    entryNo: '第 {number} 段',
    startDate: '開始時間',
    endDate: '結束時間',
    status: '狀態',
    pending: '待填寫',
    submitted: '已提交',
    cancelled: '已取消',
    noData: '暫無數據',
    configMissing: '配置缺失',
    confirmed: '已確認',
    unconfirmed: '未確認',
    signature: '簽名',
    clickToSign: '點擊簽名',
    resign: '重新簽名',
    jobApplication: '應聘登記表',
    reactivateRecord: '{name} 於 {time} 重新激活，原因：{reason}'
  },
  message: {
    resetEmailSuccess: ' 重置密碼郵件已發送到您的郵箱，請查看您的郵箱繼續。',
    wrongEmail: '無法重置密碼，請檢查填寫的郵箱地址',
    questionnaireFinished: '已完成調查問卷',
    questionnaireFinishedText1: '恭喜你已完成了全部問題',
    questionnaireStepZeroText1: '請按照以下流程填寫信息。',
    questionnaireStepZeroText2: '使用流程下方的按鈕進行導航。',
    questionnaireStepZeroText3: '點擊取消鍵可以以後再進入文書頁面填寫信息，之前填寫的信息會被保存。',
    fileChangedButNoUpload: '文件已修改但未上傳，確定離開？'
  },
  error: {
    passwordNotSame: '兩次輸入的密碼不一致',
    fileNotUpload: '請上傳附件',
    fileSize: '文件大小不能超過4MB',
    isRequired: '該字段不能為空',
    login: '用戶名或密碼錯誤',
    passwordTip: '密碼必須包含大小寫字母和數字，長度至少10位，特殊符號只能是_#@.-',
    noSteps: '未獲取到調查問卷具體步驟，請刷新後重試',
    uploadError: '上傳文件失敗，請重試',
    uploadSuccess: '上傳文件成功',
    phoneError: '電話格式不正確',
    birthIsNeeded: '需要提供出生日期。',
    ageTooSmall: '您已經指出您的年齡不足16歲。您必須至少16歲，這樣才能為我們公司工作。',
    nameNotEn: '請檢查並確保您是以拼音或英文作輸入方可進入下一頁',
    nationalIDIssueDateIsNeeded: '要求提供國民身份證簽發日期',
    nationalIDExpireDateIsNeeded: '要求提供國民身份證到期日期',
    nationalIDExpireLargeThanIssue: '國民身份證簽發日期應當早於到期日期。',
    nationalIDExpireLargeThanNow: '國民身份證到期日期應該是將來的某個日期。',
    nationalIDRegex: '請輸入有效的{nationID}。使用格式{format}',
    mustSelected: '該選項必須勾選',
    tryAgain: '請重試',
    minRows: '至少需要填寫 {count} 段',
    signatureRequired: '請完成簽名',
    signatureUploadFailed: '簽名上傳失敗，請重試'
  }
}
